import { log } from '@/log'
import { PageParts } from '@/models/game/response/result'
import GameResultApiService from '@/services/api/game-result'

export class GameResultService {

  static build(
    campaignId: string,
    brandEnglishName: string
  ): GameResultService {

    return new GameResultService(
      new GameResultApiService(),
      campaignId,
      brandEnglishName
    )
  }

  constructor(
    private _gameResultApiService: GameResultApiService,
    private _campaignId: string,
    private _brandEnglishName: string
  ) {}

  /**
   * ゲーム結果ページに必要なデータのgetを試みる。
   *
   * @return {Promise<PageParts | undefined>}
   *    正常系ではPagePartsが返り、リダイレクトする場合にundefinedが返る
   * @throws getメソッドに失敗、もしくはレスポンスの型がおかしい
   */
  async tryToGetPageParts(): Promise<PageParts | undefined> {

    const eitherGameResultContents = await this._gameResultApiService.get(
      this._campaignId,
      this._brandEnglishName
    )

    if (eitherGameResultContents.isLeft()) {
      throw this.createErrorWithLog('failed to get game result response.')
    }

    const gameResult = eitherGameResultContents.value

    if (gameResult.redirectUrl) {
      location.href = gameResult.redirectUrl

      return
    }

    if (gameResult.pageParts) {
      return gameResult.pageParts
    }

    throw this.createErrorWithLog('response type is invalid.')

  }

  private createErrorWithLog(message: string): Error {
    log.error(message)

    return new Error(message)
  }
}
